import { media } from '../../../common/utils/utils';
import uikit from '../../uikit/styles';

const stylesheets = (width, height, variable = {}) => ({
    containerStore: media(width, height, 'w', {
        1536: {
            'padding-top': '138px',
            margin: '0 auto',
            width: '100%',
            display: 'flex',
            'flex-direction': 'column',
            'background-color': variable.greyColor,
            'overflow-x': 'hidden',
            'flex-grow': 1
        },
        992: {
            'padding-top': '130px',
            margin: '0 auto',
            width: '100%',
            display: 'flex',
            'flex-direction': 'column',
            // color: variable.darkHalfTransparentColor,
            'background-color': variable.greyColor,
            'overflow-x': 'hidden',
            'flex-grow': 1
        },
        768: {
            'padding-top': '130px',
            margin: '0 auto',
            width: '100%',
            display: 'flex',
            'flex-direction': 'column',
            // color: variable.darkHalfTransparentColor,
            'background-color': variable.greyColor,
            'overflow-x': 'hidden',
            'flex-grow': 1
        },
        0: {
            'padding-top': '116px',
            margin: '0 auto',
            width: '100%',
            display: 'flex',
            'flex-direction': 'column',
            // color: variable.darkHalfTransparentColor,
            'background-color': variable.greyColor,
            'overflow-x': 'hidden',
            'flex-grow': 1
        }
    }),
    buttonPrimary: {
        ...uikit.button,
        'background-color': variable.orangeColor,
        ...uikit.title,
        'font-weight': 500,
        color: variable.whiteColor,
        width: '275px',
        'margin-top': '12px',
        transition: variable.transition
    },
    buttonPrimarySearch: {
        ...uikit.button,
        'background-color': variable.orangeColor,
        'font-size': '1rem',
        'font-weight': 500,
        color: variable.whiteColor,
        //width: '90px',
        height: '44px',
        'border-radius': '0px 8px 8px 0px',
        transition: variable.transition
    },
    formButtonPrimaryHover: { 'background-color': variable.orangeDarkColor },
    headerButton: {
        color: variable.whiteColor,
        'font-weight': 500,
        display: 'flex',
        'align-items': 'center',
        width: '411px',
        height: '100%',
        'padding-left': '20px',
        'background-color': variable.darkTransparentColor,
        cursor: 'pointer',
        'margin-right': '24px',
        'flex-shrink': 0
    },
    catalog: media(width, height, 'w', {
        1536: {
            position: 'fixed',
            top: '138px',
            width: '100%',
            'z-index': 9999
        },
        992: {
            position: 'fixed',
            top: '130px',
            width: '100%',
            'z-index': 9999
        },
        768: {
            position: 'fixed',
            top: '120px',
            width: '100%',
            'z-index': 9999
        },
        0: {
            position: 'fixed',
            top: '116px',
            width: '100%',
            'z-index': 9999
        }
    }),
    catalogWrapperMain: media(width, height, 'w', {
        1726: {
            //width: '1716px',
            'width': '80%',
            'max-width': '1504px',
            'margin': '0 auto',
            'max-height': '80vh',
            'overflow-y': 'auto'
        },
        1504: {
            //width: '1504px',
            'max-width': '90%',
            'margin': '0 auto',
            padding: '0 16px',
            'max-height': '80vh',
            'overflow-y': 'auto'
        },
        1024: {
            width: '90%',
            'margin': '0 auto',
            padding: '0 16px',
            'max-height': '80vh',
            'overflow-y': 'auto'
        },
        768: {
            width: '90%',
            'margin': '0 auto',
            padding: '0 16px'
        },
        0: {
            'background-color': variable.whiteColor,
            width: '100%'
        }
    }),
    catalogWrapperMainInner: media(width, height, 'w', {
        1700: {
            'background-color': variable.whiteColor,
            display: 'flex',
            'border-radius': '0px 0px 14px 14px',
            transition: 'all .2s linear'

        },
        1504: {
            'background-color': variable.whiteColor,
            display: 'flex',
            'border-radius': '0px 0px 14px 14px'

        },
        0: {
            'background-color': variable.whiteColor,
            'border-radius': '0px 0px 14px 14px',
            display: 'flex'


        }
    }),
    backgroundCatalog: {
        position: 'fixed',
        width: '100%',
        height: '100vh',
        'z-index': '-1',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        'background-color': variable.darkTransparentColor
    },
    subcatalog: media(width, height, 'w', {
        768: {
            width: 'calc(100% - 411px)',
            'max-height': '432px',
            padding: '24px',
            display: 'flex',
            'flex-direction': 'column',
            'flex-wrap': 'wrap',
            'align-content': 'flex-start',
            'word-break': 'break-word'
        },
        0: {
            width: '100%',
            padding: '12px',
            display: 'flex',
            'flex-direction': 'column',
            'flex-wrap': 'wrap',
            'align-content': 'flex-start',
            'word-break': 'break-word'
        }
    }),
    subcatalogBig: { 'max-height': '800px' },
    subcatalogItem: {
        width: '20%',
        'padding-right': '6px'
    },
    subcatalogFLTitle: {
        color: variable.blueColor,
        'font-weight': 500,
        'margin-bottom': '9px',
        cursor: 'pointer',
        'word-break': 'break-word',
        display: 'block'
    },
    subcatalogSLTitle: {
        ...uikit.small,
        'line-height': '1.7',
        cursor: 'pointer',
        'word-break': 'break-word',
        display: 'block'
    },
    subcatalogSLTitleLast: { 'margin-bottom': '24px' },
    breadcrumb: media(width, height, 'w', {
        1726: {
            width: '1704px',
            display: 'flex',
            'align-items': 'center',
            padding: '24px 0'
        },
        1500: {
            width: '1504px',
            display: 'flex',
            'align-items': 'center',
            padding: '24px 16px'
        },
        768: {
            width: '100%',
            display: 'flex',
            'align-items': 'center',
            'padding': '24px 16px'
        },
        0: {
            width: '100%',
            display: 'flex',
            'align-items': 'center',
            'padding': '16px 12px'
        }
    }),
    breadItem: {
        display: 'flex',
        'align-items': 'center',
        'margin-right': '10px',
        color: variable.blueColor,
        ...uikit.small,
        cursor: 'pointer'
    },
    breadItemActive: { color: variable.greySuperDarkColor },
    breadItemTitle: media(width, height, 'w', {
        768: {
            'margin-right': '10px',
            cursor: 'pointer'
        },
        0: { 'margin-left': '10px' }
    }),
    breadItemTitleLong: media(width, height, 'w', {
        768: { 'word-break': 'break-word' },
        0: { 'word-break': 'break-word' }
    }),
    cart: media(width, height, 'w', {
        1056: {
            width: '1200px',
            padding: '0 64px',
            'max-height': '70vh',
            'overflow-y': 'auto',
            'max-width': '100vw'
        },
        576: {
            width: '100%',
            padding: '0 24px',
            'max-height': '60vh',
            'overflow-y': 'auto',
            'max-width': '100vw'
        },
        0: {
            width: '100%',
            'max-width': '100vw',
            'max-height': '60vh',
            'overflow-y': 'auto'
        }
    }),
    cartHeaderTitle: media(width, height, 'w', {
        768: {
            'background-color': variable.greySuperExtraDarkTransparentColor,
            'height': '96px',
            'display': 'flex',
            'justify-content': 'space-between',
            'align-items': 'center',
            ...uikit.h6,
            padding: '0 64px',
            'margin-bottom': '24px'
        },
        0: {
            'display': 'flex',
            'justify-content': 'space-between',
            'align-items': 'center',
            ...uikit.h6,
            // padding: '0 64px',
            'margin-bottom': '18px'
        }
    }),
    cartCartTitle: {
        display: 'flex',
        'margin-bottom': '12px'
    },
    cartIcon: media(width, height, 'w', {
        768: {
            position: 'relative',
            'cursor': 'pointer',
            fill: variable.whiteColor
        },
        0: {
            //fill: variable.greyExtraDarkColor,
            width: '42px',
            height: '42px',
            'border-radius': '50%',
            background: '#2C4135',
            position: 'fixed',
            'cursor': 'pointer',
            top: '30px',
            right: 'calc(70px + 32px)',
            'z-index': '9999',
            transform: 'translateY(-50%)',
            ...uikit.flexRow,
            ...uikit.alignItemsCenter,
            ...uikit.justifyContentCenter,
            fill: variable.whiteColor
        }
    }),
    cartIconItem: media(width, height, 'w', {
        768: {
            position: 'absolute',
            top: '-5px',
            right: '-10px',
            width: '20px',
            height: '20px',
            'border-radius': '50%',
            'background-color': variable.orangeColor,
            color: variable.whiteColor,
            ...uikit.tiny,
            display: 'flex',
            'justify-content': 'center',
            'align-items': 'center'
        },
        0: {
            position: 'absolute',
            top: '-5px',
            right: '-5px',
            width: '16px',
            height: '16px',
            'border-radius': '50%',
            'background-color': variable.orangeColor,
            color: variable.whiteColor,
            ...uikit.tiny,
            display: 'flex',
            'justify-content': 'center',
            'align-items': 'center'
        }
    }),
    cartImageNo: { 'margin': '12px' },
    cartTitleNo: {
        'margin': '16px',
        'font-weight': 500,
        'font-size': '1.25rem'
    },
    cartSubtitleNo: media(width, height, 'w', {
        992: {
            'margin': '0 auto 24px auto',
            width: '450px'
        },
        0: { 'margin': '0 auto 24px auto' }
    }),
    cartWidgetWrap: { position: 'relative' },
    cartWidget: {
        position: 'absolute',
        'z-index': 9999,
        top: '45px',
        right: '-15px',
        'background-color': variable.whiteColor,
        padding: '20px',
        width: '628px',
        'border-radius': '14px',
        'box-shadow': `0 0 5px 5px ${variable.blackTransparentColor}`
    },
    cartWidgetBackground: {
        position: 'fixed',
        'z-index': 999,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
    },
    cartTriangle: {
        position: 'absolute',
        top: '-15px',
        right: '15px',
        width: '33px',
        height: '15px'
    },
    footerInfo: media(width, height, 'w', {
        1700: {
            display: 'flex',
            'justify-content': 'space-between',
            padding: '24px 0',
            'border-bottom': `1px solid ${variable.darkExtraTransparentColor}`
        },
        1024: {
            display: 'flex',
            'justify-content': 'space-between',
            padding: '24px 16px',
            'border-bottom': `1px solid ${variable.darkExtraTransparentColor}`
        },
        0: {
            width: '100%',
            display: 'flex',
            'flex-direction': 'column',
            padding: '12px'
        }
    }),
    footerInfoBody: media(width, height, 'w', {
        1700: { display: 'flex' },
        768: { display: 'flex' },
        0: {
            display: 'flex',
            'flex-direction': 'column'
        }
    }),
    footerSocial: {
        display: 'flex',
        'align-items': 'center'
    },
    footerSocialIcon: {
        width: '48px',
        height: '48px',
        'border-radius': '50%',
        'margin-right': '8px',
        display: 'flex',
        'justify-content': 'center',
        'align-items': 'center',
        'cursor': 'pointer'
    },
    footerSocialIconHover: { opacity: 0.8 },
    footerInfoContact: media(width, height, 'w', {
        1700: { width: '230px' },
        768: { width: '230px' },
        0: {
            width: '100%',
            'text-align': 'center',
            'padding-bottom': '16px',
            'border-bottom': `1px solid ${variable.darkSuperTransparentColor}`
        }
    }),
    titleAccordionWrapper: {
        display: 'flex',
        'justify-content': 'space-between',
        'align-items': 'center',
        // padding: '12px 0',
        cursor: 'pointer'

    },
    footerInfoPhone: {
        ...uikit.h5,
        'font-weight': 500,
        color: variable.blueColor,
        'margin-bottom': '11px'
    },
    footerInfoTime: {
        ...uikit.small,
        'margin-bottom': '11px'
    },
    footerInfoSubtitle: {
        ...uikit.tiny,
        color: variable.greyExtraDarkColor
    },
    footerSocialTitle: {
        ...uikit.title,
        'margin-bottom': '16px'
    },
    footerAccordionTitle: {
        ...uikit.title,
        'margin-bottom': '16px'
    },
    footerAccordionTitleMob: {
        ...uikit.small,
        'padding': '14px 0 '
    },
    footerAccordionBodyItem: {
        color: variable.blueTotalGray,
        ...uikit.small,
        'margin-bottom': '12px',
        transition: variable.transition,
        cursor: 'pointer'
    },
    footerAccordionBodyItemHover: { color: variable.blueColor },
    footerLinkMobile: media(width, height, 'w', {
        1700: {
            'background-color': variable.blueColor,
            height: '80px',
            'margin-top': '100px'
        },
        1024: {
            'background-color': variable.blueColor,
            height: '80px',
            'margin-top': '100px',
            'padding': '0 16px'
        },
        768: {
            'background-color': variable.blueColor,
            height: '140px',
            'margin-top': '100px',
            'padding': '0 16px'
        },
        0: {
            width: '100%',
            'background-color': variable.blueColor,
            height: '310px',
            'border-radius': '20px 20px 0px 0px'
            // 'margin-top': '100px',
            // 'padding': '0 32px'
        }
    }),
    footerLinkMobileWrapper: media(width, height, 'w', {
        1700: {
            display: 'flex',
            'justify-content': 'space-between',
            'align-items': 'center',
            height: '100%'
        },
        768: {
            display: 'flex',
            'justify-content': 'space-between',
            'align-items': 'center',
            height: '100%'
        },
        0: {
            display: 'flex',
            'justify-content': 'space-between',
            'align-items': 'center',
            height: '100%',
            'flex-direction': 'column'
        }
    }),
    footerLinkMobileImage: media(width, height, 'w', {
        992: {
            width: '320px',
            position: 'relative',
            height: '100%',
            order: 1
        },
        768: {
            width: '350px',
            position: 'relative',
            height: '100%',
            order: 1
        },
        0: {
            width: '320px',
            position: 'relative',
            height: '100%',
            order: 3
        }
    }),
    footerLinkMobileText: media(width, height, 'w', {
        768: {
            color: variable.whiteColor,
            'font-weight': 500,
            'font-size': '1.375rem',
            order: 2
        },
        0: {
            color: variable.whiteColor,
            'font-weight': 500,
            'font-size': '1.375rem',
            'margin-top': '24px',
            'margin-bottom': '16px',
            order: 1
        }
    }),
    footerLinkMobileButtons: media(width, height, 'w', {
        1024: {
            display: 'flex',
            'align-items': 'center',
            order: 2
        },
        768: {
            display: 'flex',
            'flex-direction': 'column',
            'justify-content': 'center',
            'align-items': 'center',
            order: 2
        },
        0: {
            display: 'flex',
            'align-items': 'center',
            order: 1
        }
    }),
    footerMobileStore: media(width, height, 'w', {
        992: {
            padding: '9px 16px',
            'border-radius': '14px',
            'background-color': variable.whiteColor,
            'font-size': '0.625rem',
            display: 'flex',
            'align-items': 'center',
            cursor: 'pointer'
            , width: '100%', 'margin-right': '8px'
        },
        768: {
            padding: '9px 16px',
            'border-radius': '14px',
            'background-color': variable.whiteColor,
            'font-size': '0.625rem',
            display: 'flex',
            'align-items': 'center',
            cursor: 'pointer',
            'margin-bottom': '8px', width: '100%', 'margin-right': '8px'
        },
        0: {
            padding: '9px 16px',
            'border-radius': '14px',
            'background-color': variable.whiteColor,
            'font-size': '0.625rem',
            display: 'flex',
            'align-items': 'center',
            cursor: 'pointer', width: '100%', 'margin-right': '8px'
        }
    }),
    footerMobileStoreHover: {
        color: variable.blueColor,
        fill: variable.blueColor
    },
    footerImage: {
        position: 'absolute',
        bottom: 0,
        'height': '175px'
    },
    footerImageItem: { height: '100%' },
    //Search
    wrapperSearch: media(width, height, 'w', {
        1840: {
            'max-width': '900px',
            width: '900px',
            'margin': 0
        },
        1700: {
            'max-width': '800px',
            width: '800px',
            'margin': 0
        },
        1366: {
            'max-width': '600px',
            width: '600px',
            'margin': 0
        },
        1100: {
            'max-width': '100%',
            width: '400px',
            'margin': 0
        },
        992: {
            'max-width': '100%',
            width: '300px',
            'margin': 0
        },
        768: {
            'max-width': '100%',
            width: '400px',
            'margin': 0
        },
        0: {
            'max-width': '100%',
            width: '100%',
            // 'padding': '0 12px',
            'margin': 0
        }
    }),
    storeSearchWrapper: media(width, height, 'w', {
        768: {
            display: 'flex',
            'align-items': 'center',
            'justify-content': 'space-between',
            'height': '100%'
        },
        0: {
            display: 'flex',
            width: '100%'
        }
    }),
    storeSearch: media(width, height, 'w', {
        768: {
            display: 'flex',
            position: 'relative',
            'word-break': 'break-word'
        },
        0: {
            display: 'flex',
            position: 'relative',
            width: '100%'
        }
    }),
    storeSearchItem: media(width, height, 'w', {
        768: {
            'padding': '8px 18px',
            cursor: 'pointer',
            transition: variable.transition

        },
        0: {
            'padding': '8px 18px',
            cursor: 'pointer',
            transition: variable.transition,
            width: '100%'
        }
    }),
    searchItemNo: { 'padding': '8px 18px' },
    storeSearchItemHover: {
        color: variable.blueColor,
        background: variable.greyExtraDarkTransparentColor,
        'border-radius': '8px'
    },
    fieldSearch: {
        position: 'absolute',
        top: '48px',
        left: 0,
        width: '100%',
        padding: '18px 8px',
        'background-color': variable.whiteColor,
        'border-radius': '14px',
        'z-index': 99
    },
    fieldSearchBackground: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        'background-color': variable.darkTransparentColor,
        'z-index': -1
    },
    inputSearch: media(width, height, 'w', {
        1700: {
            'max-width': '900px',
            ...uikit.flexRow,
            'line-height': 1,
            //width: '900px',
            //'padding': '10px 16px',
            'margin': 0,
            //'height': '44px',
            //'min-height': '44px',
            'border-radius': '8px 0px 0px 8px',
            'border': 'none'
        },
        1366: {
            'max-width': '600px',
            ...uikit.flexRow,
            'line-height': 1,
            //width: '600px',
            'margin': 0,
            //'padding': '10px 16px',
            //'height': '44px',
            //'min-height': '44px',
            'border-radius': '8px 0px 0px 8px',
            'border': 'none'
        },
        768: {
            width: '100%',
            'margin': 0,
            ...uikit.flexRow,
            'line-height': 1,
            //'height': '44px',
            //'padding': '10px 16px',
            //'min-height': '44px',
            'border-radius': '8px 0px 0px 8px',
            'border': 'none'
        },
        0: {
            // 'max-width': '400px',
            width: '100%',
            'margin': 0,
            //'height': '44px',
            //'min-height': '44px',
            'line-height': 1,
            //'padding': '10px 16px',
            'border-radius': '8px',
            'border': 'none'

        }
    }),
    iconSearch: {
        position: 'absolute',
        top: '22px',
        left: '18px',
        transform: 'translateY(-50%)'
    },
    //OLD
    mainWrapperWeb: {
        background: `${variable.mainWrapperWebBackground}, url(../../../../src/img/zendo_2_bg.jpg)`,
        'background-repeat': 'no-repeat',
        'background-size': 'cover',
        'background-position': 'center'
        // 'transition': 'background 2s'
    },
    mainWrapperWebLogin: { background: `${variable.mainWrapperWebBackground}, url(../../../../src/img/zendo_2_bg.jpg)` },
    mainWrapperWebRegister: { background: `${variable.mainWrapperWebRegisterBackground}, url(../../../../src/img/zendo_2_bg.jpg)` },
    mainWrapperWebRestore: { background: `${variable.mainWrapperWebRestoreBackground}, url(../../../../src/img/zendo_2_bg.jpg)` },
    mainContainerWeb: media(width, height, 'w', {
        768: {
            'max-width': variable.containerWidth,
            margin: '0 auto',
            width: '100%',
            padding: '0 20px',
            'min-height': '100%',
            display: 'flex',
            'flex-direction': 'column',
            'flex-grow': '1'
        },
        0: {
            'max-width': variable.containerWidth,
            margin: '0 auto',
            width: '100%',
            padding: '0',
            height: '100%',
            display: 'flex',
            'flex-direction': 'column'
        }
    }),
    blockXl: media(width, height, 'w', {
        // 1700: {
        //     'max-width': '1716px',
        //     'margin-left': 'auto',
        //     'margin-right': 'auto'
        // },
        // 1536: {
        //     'max-width': '1504px',
        //     'margin-left': 'auto',
        //     'margin-right': 'auto'
        // },
        // 1100: {
        //     // 'max-width': '1024px',
        //     'margin-left': 'auto',
        //     'margin-right': 'auto'
        // },
        // 0: { 'max-width': '100%' }
        1726: {
            'width': '80%',
            'max-width': '1504px',
            'margin-left': 'auto',
            'margin-right': 'auto'
        },
        1500: {
            'max-width': '90%',
            'margin-left': 'auto',
            'margin-right': 'auto'
        },
        768: {
            'max-width': '90%',
            'margin-left': 'auto',
            'margin-right': 'auto'
        },
        0: {
            'width': '100%',
            'margin-left': 'auto',
            'margin-right': 'auto'
        }
    }),
    flexColumn: { 'flex-direction': 'column' },
    headerShadow: { 'box-shadow': `0px 5px 20px ${variable.blackExtraTransparentColor}` },
    mainHeader: media(width, height, 'w', {
        1536: {
            display: 'flex',
            padding: '20px 0'
        },
        0: {
            display: 'flex',
            'flex-direction': 'row',
            'justify-content': 'flex-end',
            padding: '8px 16px',
            'min-height': '60px'
        }
    }),
    mainMenuWrapper: {
        width: '100%',
        display: 'flex',
        'flex-direction': 'row',
        'justify-content': 'flex-end'
    },
    mainMenuHamburgerNativeDisactive: { display: 'none' },
    mainMenuLogo: media(width, height, 'w', {
        993: {
            display: 'flex',
            'justify-content': 'flex-start',
            order: '-1',
            'flex-grow': '1',
            'align-items': 'center'
        },
        0: {
            display: 'flex',
            'justify-content': 'center',
            'align-items': 'center',
            'max-width': 'calc(100% - 44px - 26px)'
        }
    }),
    mainMenuLogoLink: media(width, height, 'w', {
        993: {
            'max-width': '100%',
            'padding-left': '0'
        },
        0: {
            'max-width': '100%',
            'padding-left': '8px'
        }
    }),
    mainMenuLogoImg: media(width, height, 'w', {
        1320: {},
        992: {
            'max-width': '100%',
            display: 'inline-flex'
        }
    }),
    mainMenuLogoNative: {
        993: { display: 'none' },
        0: {
            display: 'flex',
            'justify-content': 'center',
            'align-items': 'center'
            // 'order': '1'
        }
    },
    mainMenuHamburgerNativeImg: {
        width: '20px',
        height: '20px'
    },
    mainContent: {
        display: 'flex',
        'flex-grow': 1
    },
    wrapAuthBlockWeb: {
        display: 'flex',
        'flex-direction': 'column',
        'justify-content': 'center',
        flex: '1'

    },
    authBlockWeb: media(width, height, 'w', {
        768: {
            background: variable.whiteColor,
            'box-shadow': `0px 30px 60px ${variable.greyShadowColor}`,
            'border-radius': '24px',
            'max-width': '480px',
            width: '100%',
            display: 'flex',
            'flex-direction': 'column',
            padding: '48px 40px',
            margin: '0 auto 0',
            position: 'relative'
        },
        0: {
            position: 'absolute',
            top: '-100%'
        }
    }),
    authBlockWebActive: {
        background: variable.whiteColor,
        'box-shadow': `0px 30px 60px ${variable.greyShadowColor}`,
        'border-radius': '24px',
        width: '100%',
        'flex-direction': 'column',
        'justify-content': 'space-between',
        'flex-grow': '1',
        display: 'flex',
        padding: '32px 16px 16px 16px',
        margin: '0 auto 0'
    },
    authBlockNativeActive: {
        background: variable.whiteColor,
        'box-shadow': `0px 30px 60px ${variable.greyShadowColor}`,
        'border-radius': '24px',
        width: '100%',
        'flex-direction': 'column',
        'justify-content': 'space-between',
        'flex-grow': '1',
        display: 'flex',
        padding: '32px 16px 16px 16px',
        margin: '0 auto 0'
    },
    authBlockNativeNotActive: { display: 'none' },
    authHeading: {
        display: 'flex',
        'flex-direction': 'row',
        'margin-bottom': '24px'
    },
    authHeadingTitle: {
        'font-weight': '500',
        ...uikit.h5,
        color: variable.blueDarkColor,
        'text-align': 'center',
        background: 'transparent',
        flex: 1,
        'margin-bottom': '16px'
    },
    authHeadingText: {
        ...uikit.text,
        color: variable.blueDarkColor,
        'text-align': 'center',
        background: 'transparent'
    },
    wrapButtonMenu: {
        padding: '16px',
        'border-color': variable.greyColor,
        'border-width': '1px',
        'border-style': 'solid',
        'border-left-width': '0',
        'border-right-width': '0',
        'margin-bottom': '24px'
    },
    button: {
        'border-radius': '14px',
        height: '48px',
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'center',
        margin: '8px 0'
    },
    buttonGray: { 'background-color': variable.greyTransparentColor },
    buttonOrange: { 'background-color': variable.orangeColor },
    buttonOrangeHover: { 'background-color': variable.orangeLightColor },
    buttonGrayHover: {
        'background-color': variable.greyColor,
        cursor: 'pointer',
        'user-select': 'none'
    },
    buttonGrayFocus: { 'background-color': variable.greyLightColor },
    buttonOrangeText: {
        'font-weight': '500',
        ...uikit.text,
        color: variable.whiteColor
    },
    wrapLinksMenu: { padding: '0 16px' },
    mainMenu: media(width, height, 'w', {
        993: {
            display: 'flex',
            // margin: '0 -5px',
            'flex-grow': '1',
            // 'justify-content': 'space-between',
            'flex-direction': 'row',
            position: 'relative',
            'justify-content': 'space-between',
            'margin-bottom': '16px',
            'margin-top': '24px',
            'align-items': 'center'
        },
        0: {
            display: 'flex',
            // margin: '0 -5px',
            'flex-grow': '1',
            // 'justify-content': 'space-between',
            'flex-direction': 'row',
            position: 'relative',
            'justify-content': 'center',
            'margin-bottom': '16px',
            'margin-top': '24px',
            'align-items': 'center'
        }
    }),
    mainMenuItem: media(width, height, 'w', {
        1200: {
            ...uikit.subtitle,
            'font-weight': variable.menuLinkFontWeight,
            padding: '0',
            color: variable.darkColor,
            transition: 'color 0.5s',
            'margin-right': '56px'
        },
        993: {
            ...uikit.subtitle,
            'font-weight': variable.menuLinkFontWeight,
            padding: '0',
            color: variable.darkColor,
            transition: 'color 0.5s',
            'margin-right': '22px'
        },
        0: {
            'font-size': variable.menuLinkFontSize,
            'font-weight': variable.menuLinkFontWeight,
            padding: '0 5px',
            color: variable.darkColor,
            'margin-bottom': '16px',
            display: 'block'
        }
    }),
    mainMenuItemHover: {
        cursor: 'pointer',
        color: variable.blueColor,
        fill: variable.blueColor,
        opacity: '0.5'
    },
    imgBackground: {
        width: '100%',
        flex: 1,
        display: 'flex',
        'flex-direction': 'column',
        position: 'relative'
    },
    webMenuBlock: media(width, height, 'w', {
        993: {
            display: 'flex',
            'align-items': 'center'
        },
        0: { display: 'none' }
    }),
    footerBlockWeb: media(width, height, 'w', {
        768: {
            display: 'flex',
            'flex-direction': 'row',
            'justify-content': 'space-between',
            'margin-top': '32px',
            'margin-bottom': '32px'
        },
        0: { display: 'none' }
    }),
    footerBlockNative: { display: 'none' },
    footerText: {
        color: variable.whiteColor,
        ...uikit.small
    },
    NativeMenuBlock: {
        position: 'absolute',
        top: '0',
        left: '-100%',
        width: '100%',
        height: '100%',
        display: 'flex',
        color: variable.whiteColor,
        'z-index': '10',
        'background-color': variable.blackTransparentColor
    },
    NativeMenu: {
        display: 'flex',
        'flex-direction': 'column',
        width: '250px',
        'border-radius': '5px',
        padding: ' 15px',
        left: '0',
        top: '0',
        'background-color': variable.whiteColor,
        height: '100%'
    },
    WebMenu: {
        display: 'flex',
        'flex-direction': 'column',
        left: '0',
        top: '0',
        'background-color': variable.whiteColor,
        height: '100vh',
        'box-shadow': `0px 5px 20px ${variable.blackExtraTransparentColor}`,
        padding: '24px 0',
        'border-radius': '0',
        'border-top-right-radius': '20px',
        width: '278px'
    },
    AuthMenu: {
        padding: '24px 0',
        'border-radius': '0',
        'border-top-right-radius': '20px',
        width: '278px'
    },
    formLinkText: {
        color: variable.whiteColor,
        ...uikit.small,
        'font-weight': '500'
    },
    marginLeft24: { ...uikit.ml4 },
    dFlex: { display: 'flex' },
    buttonYellow: {
        'background-color': variable.orangeColor,
        transition: 'all ease .25s',
        color: variable.whiteColor
    },
    buttonYellowHover: {
        'background-color': variable.orangeDarkColor,
        color: variable.whiteColor,
        transition: 'all ease .25s'
    },
    justifyContentBetween: { 'justify-content': 'space-between' },
    enterButton: media(width, height, 'w', {
        1536: {
            'font-weight': '500',
            'min-width': '113px',
            'min-height': '48px',
            ...uikit.text,
            display: 'inline-flex',
            'align-items': 'center',
            'flex-direction': 'column',
            'justify-content': 'center',
            cursor: 'pointer',
            'border-radius': '14px',
            'margin-right': '24px'
        },
        0: {
            'font-weight': '500',
            'min-width': '113px',
            'min-height': '48px',
            ...uikit.text,
            display: 'inline-flex',
            'align-items': 'center',
            'flex-direction': 'column',
            'justify-content': 'center',
            cursor: 'pointer',
            'border-radius': '14px',
            'margin-right': '18px'
        }
    }),
    langSwitcher: media(width, height, 'w', {
        992: { width: '74px' },
        0: { width: '44px' }
    }),
    headerSticky: {
        position: 'fixed',
        top: '0px'
    },
    bgcWhite: { 'background-color': variable.whiteColor },
    fullWidth: { width: '100%' },
    footerDown: { 'background-color': variable.whiteColor },
    footer: media(width, height, 'w', {
        1536: {
            display: 'flex',
            'justify-content': 'space-between',
            padding: '16px 0',
            color: variable.greyExtraDarkColor
        },
        576: {
            display: 'flex',
            'justify-content': 'space-between',
            padding: '16px',
            color: variable.greyExtraDarkColor
        },
        0: {
            display: 'flex',
            'justify-content': 'center',
            'align-items': 'center',
            'flex-direction': 'column',
            padding: '16px',
            width: '100%'
        }
    }),
    copyright: {
        'font-weight': 'normal',
        ...uikit.small,
        color: variable.greyExtraDarkColor
    },
    dev: {
        display: 'flex',
        'flex-direction': 'row',
        'align-items': 'center',
        color: variable.greyExtraDarkColor

    },
    devText: {
        ...uikit.small,
        color: variable.greySuperDarkColor,
        'margin-right': '4px'
    },
    devLink: {
        ...uikit.small,
        color: variable.blueColor,
        'font-weight': '500'
    },
    devLinkHover: { 'text-decoration': 'underline' },
    cursorPointer: { ...uikit.pointer },
    centered: {
        'margin-left': 'auto',
        'margin-right': 'auto'
    },

    // HEADER
    headerWrapper: media(width, height, 'w', {
        1536: {
            // 'margin-top': '88px',
            position: 'fixed',
            'z-index': 10000,
            height: '56px',
            'background-color': variable.blueColor,
            width: '100%',
            top: '82px'
        },
        992: {
            position: 'fixed',
            'z-index': 10000,
            top: '64px',
            height: '64px',
            width: '100%',
            'background-color': variable.blueColor
        },
        768: {
            position: 'fixed',
            'z-index': 10000,
            top: '67px',
            height: '54px',
            width: '100%',
            'background-color': variable.blueColor
        },
        0: {
            position: 'fixed',
            'z-index': 8,
            top: '67px',
            height: '56px',
            width: '100%',
            'background-color': variable.blueColor
        }
    }),
    container: media(width, height, 'w', {
        1726: {
            //'max-width': '1716px',
            'width': '80%',
            'max-width': '1504px',
            //width: '100%',
            margin: '0 auto'
            // padding: '0 20px',
            // 'padding-top': '156px'
        },
        1500: {
            // 'max-width': '1504px',
            width: '100%',
            'max-width': '90%',
            margin: '0 auto',
            padding: '0 16px'
            // 'padding-top': '156px'
        },
        768: {
            'max-width': '90%',
            width: '100%',
            margin: '0 auto',
            padding: '0 16px'
        },
        0: {
            'max-width': '100%',
            width: '100%',
            margin: '0 auto',
            padding: '0 16px'
        }
    }),
    flex: {
        display: 'flex',
        'align-items': 'center'
    },
    flexRow: {
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'space-between',
        'height': '100%'
    },


    //MODAL
    adminFilterWindowWrapperNative: {
        // backgroundColor: variable.blackTransparentGraceColor,
        flex: 1,
        'flex-direction': 'column'
    },
    adminFilterDivSearchNative: {
        'border-radius': '0px 20px 20px 0px',
        backgroundColor: variable.whiteColor,
        paddingBottom: 20
    },
    adminFilterWindowWrapperWebFull: { width: '100%' },
    adminWindowContentWrapper: media(width, height, 'w', {
        992: {
            'flex-grow': '1',
            display: 'flex',
            'flex-direction': 'column',
            padding: '0 0 24px 0',
            'border-radius': '20px 0px 0px 20px',
            'background-color': variable.whiteColor,
            width: '100%',
            height: '100vh'
        },
        0: {
            'flex-grow': '1',
            padding: '12px 20px 0',
            'background-color': variable.whiteColor,
            width: '100%',
            'min-height': '100vh'
        }
    }),
    modalWindowClose: { cursor: 'pointer' },
    modalWindowCloseHover: { opacity: 0.5 },
    //For footer
    footerWrap: { 'margin-top': 'auto' },
    wrapper: { 'border-bottom': `1px solid ${variable.darkSuperTransparentColor}` },
    modalWrapper: {
        width: '576px',
        'max-width': '100%',
        background: variable.whiteColor,
        'border-radius': '20px',
        'margin-left': 'auto',
        'margin-right': 'auto',
        position: 'relative',
        display: 'flex',
        'flex-direction': 'column'
    },
    modalClose: {
        position: 'absolute',
        top: '24px',
        right: '30px',
        'cursor': 'pointer'
    },
    modalCloseSvg: {
        fill: variable.greyExtraDarkColor,
        width: '12px',
        height: '12px'
    },
    modalTitle: {
        'margin-bottom': '32px',
        color: variable.darkColor,
        'font-size': '20px',
        'line-height': '1.3',
        'text-align': 'center',
        'font-weight': '500'
    },
    modalHeader: {
        'padding-top': '32px',
        'padding-left': '32px',
        'padding-right': '32px'
    },
    modalBody: {
        'padding-bottom': '32px',
        'padding-left': '32px',
        'padding-right': '32px',
        'text-align': 'center'
    },
    modalBodySm: media(width, height, 'w', {
        480: {
            'padding-top': '16px',
            'padding-bottom': '26px',
            'padding-left': '26px',
            'padding-right': '26px'
        },
        0: {
            'padding-top': '16px',
            'padding-bottom': '26px',
            'padding-left': '16px',
            'padding-right': '16px'
        }
    }),
    modalBodyText: {
        'text-align': 'center',
        'font-size': '0.875rem',
        'line-height': '1.7',
        color: variable.darkHalfTransparentColor,
        'padding-bottom': '24px'
    },
    modalFooter: {
        display: 'flex',
        'flex-direction': 'row',
        'justify-content': 'center',
        'padding-left': '32px',
        'padding-right': '32px',
        'padding-bottom': '32px'
    },
    formButtonDefault: {
        'text-align': 'center',
        cursor: 'pointer',
        'border-radius': '0.875rem',
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'center',
        'font-size': '1.125rem',
        'line-height': 1.3334,
        'font-weight': 500,
        padding: '1.25rem',
        'background-color': 'rgba(246,246,248,1)',
        color: 'rgba(15,19,36,1)'
    },
    formButtonSuccess: {
        'text-align': 'center',
        cursor: 'pointer',
        'border-radius': '0.875rem',
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'center',
        'font-size': '1.125rem',
        'line-height': 1.3334,
        'font-weight': 500,
        padding: '1.25rem',
        'background-color': 'rgba(189,165,127,1)',
        color: 'rgba(15,19,36,1)'
    },
    packageBtnText: {
        color: variable.blueColor,
        ...uikit.text,
        'font-weight': '500'
    },
    packBg: media(width, height, 'w', {
        720: {
            position: 'relative',
            display: 'flex',
            'flex-direction': 'column',
            'justify-content': 'center',
            'align-items': 'center',
            padding: '8px 10px',
            width: 'calc(50% - 6px)',
            'border-radius': '14px',
            overflow: 'hidden',
            color: '#ffffff',
            'text-align': 'center',
            // 'background-size': 'cover',
            'background-repeat': 'no-repeat',
            'background-position': 'top left, center'
        },
        0: {
            position: 'relative',
            display: 'flex',
            'flex-direction': 'column',
            'justify-content': 'center',
            'align-items': 'center',
            padding: '8px 10px',
            width: '100%',
            'border-radius': '14px',
            overflow: 'hidden',
            color: '#ffffff',
            'text-align': 'center',
            // 'background-size': 'cover',
            'background-repeat': 'no-repeat',
            'background-position': 'top left, center',
            'margin-bottom': '20px'
        }
    }),
    emptyMargin: media(width, height, 'w', {
        720: { 'margin-left': '12px' },
        0: {}
    }),
    emptyBg: media(width, height, 'w', {
        720: {
            position: 'relative',
            display: 'flex',
            'flex-direction': 'column',
            'justify-content': 'center',
            'align-items': 'center',
            width: 'calc(50% - 6px)',
            padding: '8px 10px',
            'border-radius': '14px',
            overflow: 'hidden',
            // color: '#ffffff',
            'text-align': 'center',
            border: '2px solid #F4F3F4'
        },
        0: {
            position: 'relative',
            display: 'flex',
            'flex-direction': 'column',
            'justify-content': 'center',
            'align-items': 'center',
            width: '100%',
            padding: '8px 10px',
            'border-radius': '14px',
            overflow: 'hidden',
            // color: '#ffffff',
            'text-align': 'center',
            border: '2px solid #F4F3F4'
        }
    }),
    packNameLabel: {
        'font-size': '24px',
        'font-weight': 500,
        'line-height': '1'
    },
    packPriceLabel: media(width, height, 'w', {
        480: {
            'font-size': '16px',
            'font-weight': 500,
            'line-height': '1.15'
        },
        0: {
            'font-size': '14px',
            'font-weight': 500,
            'line-height': '1.15'
        }
    }),
    currentPackWrap: media(width, height, 'w', {
        720: {
            display: 'flex',
            'margin-bottom': '24px'
        },
        0: {
            // display: 'flex',
            'margin-bottom': '24px'
        }
    }),
    currentPackTitle: {
        'margin-bottom': '8px',
        color: 'rgba(255, 255, 255, 0.75)',
        'font-size': '14px',
        'font-weight': 400,
        'line-height': '1'
    },
    amountLeftTitle: {
        'margin-bottom': '8px',
        color: '#7B7979',
        'font-size': '14px',
        'font-weight': 400,
        'line-height': '1'
    },
    leftAmount: {
        display: 'flex',
        padding: '4px 8px',
        'margin-right': '12px',
        'justify-content': 'center',
        'align-items': 'center',
        'min-width': '100px',
        width: 'fit-content',
        'border-radius': '8px',
        'font-size': '16px',
        'font-weight': 600,
        'line-height': '1'
    },
    packNameWrap: media(width, height, 'w', {
        0: {
            position: 'relative',
            display: 'flex',
            'justify-content': 'center',
            'align-items': 'center',
            padding: '4px 10px',
            margin: '0 0 0 8px',
            'min-width': '126px',
            'text-align': 'center',
            'border-radius': '16px',
            color: variable.whiteColor,
            'font-size': '0.875rem',
            'line-height': '1.14',
            'font-weight': 'bold',
            'z-index': 2,
            'box-shadow': 'none'
        }
    }),
    packIconWrap: {
        display: 'flex',
        'justify-content': 'center',
        'align-items': 'center',
        'margin-right': '6px'
    },
    package_1: { 'background': 'linear-gradient(90deg, #4C3C36 0%, #A9856F 100%)' },
    package_2: { 'background': 'linear-gradient(90deg, #353A43 0%, #8796B0 100%)' },
    package_3: { 'background': 'linear-gradient(90deg, #2D4439 0%, #5BA184 100%)' },
    package_4: { 'background': 'linear-gradient(90deg, #7A5931 0%, #E1A345 100%)' },
    packNameTitle: media(width, height, 'w', {
        0: {
            display: 'flex',
            'justify-content': 'center',
            'align-items': 'center'
        }
    }),
    availableItem: {
        display: 'flex',
        // 'justify-content': 'space-between',
        'margin-bottom': '8px'
    },
    amountHas: {
        'font-size': '24px',
        'font-weight': 500,
        'line-height': '1',
        color: variable.blueColor,
        'background-color': variable.greyTransparentHalfColor,
        padding: '4px 6px',
        'border-radius': '4px',
        'white-space': 'nowrap',
        width: 'fit-content'
    },
    marPack: {
        display: 'flex',
        'align-items': 'center'
    },
    totalMarketingPrice: {
        'font-weight': 700,
        ...uikit.text,
        color: variable.blueColor,
        'background-color': variable.greyTransparentHalfColor,
        padding: '4px 6px',
        'border-radius': '4px',
        'white-space': 'nowrap',
        width: 'fit-content'
    }
});
export default stylesheets;